import { Injectable, signal, computed } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ViewportService {
  private windowWidth = signal(window.innerWidth);

  // Optional: track height too
  private windowHeight = signal(window.innerHeight);

  // Computed signal for mobile view
  readonly isMobileView = computed(() => this.windowWidth() <= 768);

  constructor() {
    // Listen to window resize events
    window.addEventListener('resize', () => {
      this.windowWidth.set(window.innerWidth);
      this.windowHeight.set(window.innerHeight);
    });
  }

  // Optional: expose dimensions
  readonly width = computed(() => this.windowWidth());
  readonly height = computed(() => this.windowHeight());
}